<!-- 公告管理 -->
<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search class="pt-3" :showSearch="false">
			<!-- 左边 -->
			<template #left>
				<el-button size="mini" type="success" @click="openModel(false)">查询</el-button>
			</template>
		</button-search>
		<div style="width: 100%;flex-flow: row wrap;margin-top: 10px;" class="d-flex">
			<div style="width: 20%;justify-content: center;align-items: center;flex-flow: column;margin-bottom: 10px;" class="d-flex" v-for="(item,index) in tableData" @click="printReport(item.cpbm)">
				<div style="margin-bottom: -10px;"><barcode :value="item.cpbm" :options="barcode_option"></barcode></div>
				<div style="font-size: 14px;">{{ item.name }}</div>
				<div style="font-size: 12px;color: #a7a7a7;">{{ item.tm }}</div>
				<div style="font-size: 12px;color: #a7a7a7;">{{ item.cpbm }}</div>
			</div>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import barcode from '@xkeshi/vue-barcode';
import getLodop from '@/components/getLodop/getLodop.js';
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
export default {
	inject: ['layout'],
	mixins: [common], // 引入mixins里的common.js
	// 引入注册
	components: {
		buttonSearch,
		barcode,
		getLodop
	},
	data() {
		return {
			preUrl: 'cptm',
			createModel: false,
			editIndex: -1,
			tableData:[],
			barcode_option: {
				displayValue: false, //是否默认显示条形码数据
				background: '#fff', //条形码背景颜色
				height: '50px',
				fontSize: '12px',
				lineColor: '#0a0dbd'
			}
		};
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			console.log(e.list)
			this.tableData = e.list;
		},
		printReport(e) {
			const LODOP = getLodop();
			// LODOP.PRINT_INIT("条形码");
			LODOP.SET_PRINT_PAGESIZE(1, '200mm',"50mm","");
			LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Full-Width');
			// LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
			LODOP.SET_PRINT_MODE('FULL_HEIGHT_FOR_OVERFLOW', true);
			// LODOP.SET_PRINT_STYLE("FontName",'微软雅黑');
			//纯文本字体间距
			// LODOP.SET_PRINT_STYLE("LetterSpacing", 35);
			// //字号
			LODOP.SET_PRINT_STYLE('FontSize', 8);
			LODOP.SET_PRINT_STYLE('Bold', 1);
			// LODOP.SET_PRINT_STYLE("PenWidth", 5);
			LODOP.ADD_PRINT_BARCODE(40, '90mm', '80mm', 85, '128Auto', e);
			LODOP.SET_PRINT_STYLEA(0, 'FontSize', 12);
			// LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
			// LODOP.SET_PRINT_STYLEA(0,"HOrient",3);
			LODOP.PREVIEW()
		},
		// 打开模态框
		openModel(e = false) {
			// 增加
			if (!e) {
				// 初始化表单
				this.form = {
					title: '',
					content: ''
				};
				this.editIndex = -1;
			} else {
				// 修改
				this.form = {
					title: e.row.title,
					content: e.row.content
				};
				this.editIndex = e.$index;
			}
			// 打开dialog
			this.createModel = true;
		},
		// 添加规格
		submit() {
			this.$refs.form.validate(res => {
				if (res) {
					let id = 0;
					if (this.editIndex !== -1) {
						id = this.tableData[this.editIndex].id;
					}
					this.addOrEdit(this.form, id);
					// 关闭模态框
					this.createModel = false;
				}
			});
		}
	}
};
</script>

<style></style>
